import React, { useState, useEffect } from 'react';
import Comm from '../comm/comm';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../css/customDatePickerWidth.css";
import { useMemo } from 'react';

const ProjectEdit = ({ setData, data }) => {


    
    let years = useMemo(() => {
        let result = [];
        for (let y = new Date().getFullYear(); y > 1900 ; y--){
            result.push(y);
        }
        return result;
    },[]);

    
    return (
        <div className="container">
            <h2 className="appeal-title mb-5">Документ</h2>
            <div className="form-row">

                <div className="form-group col-md-2">
                    <label>Номер на обект</label>
                    <input type="text" className="form-control" value={data.objectNumber} onChange={(e) => setData("objectNumber", e.target.value)} />
                </div>

                <div className="form-group col-md-6">
                    <label>Заглавие</label>
                    <input type="text" className="form-control" value={data.title} onChange={(e) => setData("title", e.target.value)} />
                </div>
                <div className="form-group col-md-4">
                    <label>Година</label>
                    <select className="form-control" value={data.year} onChange={(e) => setData("year", e.target.value)}>
                        <option value={null}></option>
                        {
                            years.map(i => <option value={i} key={i}>{i}</option>)
                        }
                    </select>
                </div>
            </div>
            
        </div>

    );
}


export default ProjectEdit;